import { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../../mock';

export default function FAQ({ onQuoteClick }) {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-16 md:py-20 cream-alt-bg">
      <div className="max-w-7xl mx-auto px-4 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 reveal">
            <p className="section-label mb-4">FAQ</p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.05] mb-6">
              Answers before the quote.
            </h2>
            <p className="text-[#212B20] text-lg leading-relaxed mb-6">
              Practical answers to the questions Ballarat homeowners ask most often before booking.
            </p>
            <button onClick={onQuoteClick} className="btn-gold px-6 py-3 rounded-md">
              Request Free Quote
            </button>
          </div>

          <div className="lg:col-span-8 space-y-3">
            {faqs.map((f, i) => {
              const isOpen = i === open;
              return (
                <div key={f.id} className={`bg-white rounded-lg border-2 shadow-sm ${isOpen ? 'border-[#0A2E18] shadow-md' : 'border-[#0A2E18]/20'} transition-colors`}>
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    data-testid={`faq-toggle-${f.id}`}
                    className="w-full flex items-center justify-between text-left px-6 py-5"
                  >
                    <span className={`font-bold pr-4 ${isOpen ? 'text-[#1B6E37]' : 'text-[#0A2E18]'}`}>{f.q}</span>
                    <span className="flex-shrink-0">
                      {isOpen ? <Minus className="w-5 h-5 text-[#1B6E37]" /> : <Plus className="w-5 h-5 text-[#0A2E18]" />}
                    </span>
                  </button>
                  {isOpen && <div className="px-6 pb-6 text-[#212B20] leading-relaxed">{f.a}</div>}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
